import { ShoesState } from 'src/types'

const lace2 = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  if (!ctx) return
  // lace
  ctx.beginPath()
  ctx.fillStyle = state.vampStrap.color
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  ctx.moveTo(241, 325)
  ctx.quadraticCurveTo(232, 334, 239, 342)
  ctx.quadraticCurveTo(249, 344, 254, 337)
  ctx.quadraticCurveTo(253, 322, 265, 324)
  ctx.quadraticCurveTo(265, 321, 265, 321)
  ctx.quadraticCurveTo(256, 317, 241, 325)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.moveTo(257, 320)
  ctx.quadraticCurveTo(244, 329, 251, 339)
  ctx.stroke()
  ctx.closePath()
}

export const instep = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.toeReinforcement.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(15, 432) //つま先＿左下
  ctx.quadraticCurveTo(27, 439, 27, 439)
  ctx.quadraticCurveTo(18, 402, 52, 375)
  ctx.quadraticCurveTo(70, 360, 100, 353)
  ctx.quadraticCurveTo(118, 349, 142, 351)
  ctx.quadraticCurveTo(217, 360, 217, 360)
  ctx.quadraticCurveTo(269, 353, 269, 353) // 右下
  ctx.quadraticCurveTo(276, 319, 276, 319) // 右上
  ctx.quadraticCurveTo(246, 330, 206, 330)
  ctx.quadraticCurveTo(163, 327, 116, 335)
  ctx.quadraticCurveTo(69, 342, 43, 368)
  ctx.quadraticCurveTo(34, 376, 21, 398)
  ctx.quadraticCurveTo(12, 416, 15, 432)
  //   ctx.quadraticCurveTo()
  //   ctx.quadraticCurveTo()
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット

  ctx.beginPath()
  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.moveTo(25, 438)
  ctx.quadraticCurveTo(20, 423, 33, 393)
  ctx.quadraticCurveTo(59, 360, 98, 352)
  ctx.quadraticCurveTo(138, 347, 184, 355)
  ctx.quadraticCurveTo(220, 362, 268, 351)
  ctx.moveTo(276, 320)
  ctx.quadraticCurveTo(269, 352, 269, 352)
  //   ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(22, 435) // 左
  ctx.quadraticCurveTo(14, 416, 35, 388)
  ctx.quadraticCurveTo(52, 362, 89, 350)
  ctx.quadraticCurveTo(122, 341, 189, 351)
  ctx.quadraticCurveTo(222, 358, 268, 347)
  ctx.quadraticCurveTo(272, 325, 272, 325)
  ctx.quadraticCurveTo(219, 335, 219, 335)
  ctx.quadraticCurveTo(202, 332, 220, 330)

  ctx.moveTo(204, 332)
  ctx.quadraticCurveTo(185, 354, 185, 354)
  ctx.moveTo(208, 332)
  ctx.quadraticCurveTo(189, 354, 189, 354)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  if (['laceType', 'unselected'].includes(state.vampStrapType.value)) {
    lace2(ctx, state)
  }
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
